import { BlockModel } from '../../../../Common/PageBuilder/models/block.model';
import { ChartDisplayElementModel } from '../../../../Common/Reports/models/chart-display-element.model';
import { ReportBlockTypeEnum } from '../../../../Common/Reports/enums/report-block-type.enum';
import moment from 'moment-timezone';


export function sharedReportDataFromOnePointOneToTwoPointOh(block: BlockModel, chartData: any): BlockModel {
    let data;
    let newDataPoints;

    switch (block.type.key) {
        case ReportBlockTypeEnum.COVERAGE_OVER_TIME:
            data = (block.displayElement as ChartDisplayElementModel).series[0].dataProvider.getValue();
            newDataPoints = [];
            const metrics = chartData.metrics;
            data.forEach(dataPoint => {
                metrics.forEach((metric, index) => {
                    newDataPoints.push({
                        label: dataPoint.label,
                        mappingKeys: dataPoint.mappingKeys || {
                            date: dataPoint.key,
                            metric: metric
                        },
                        value: dataPoint.value || dataPoint['value' + index] || 0,
                        valueLabel: dataPoint.valueLabel,
                        mentionCount: dataPoint.mentionCount,
                        rawStartDate: dataPoint.rawStartDate || dataPoint.rawDateFacetFrom,
                        rawEndDate: dataPoint.rawEndDate || dataPoint.rawDateFacetTo
                    });
                });
            });
            (block.displayElement as ChartDisplayElementModel).series[0].dataProvider.next(newDataPoints);
            break;
        case ReportBlockTypeEnum.COVERAGE_OVER_TIME_COMPARISON:
            (block.displayElement as ChartDisplayElementModel).series.forEach((s, index) => {
                newDataPoints = [];
                data = s.dataProvider.getValue();
                data.forEach(dataPoint => {
                    newDataPoints.push({
                        label: dataPoint.label,
                        mappingKeys: dataPoint.mappingKeys || {
                            date: dataPoint.key,
                            source: s.label
                        },
                        value: dataPoint.value || dataPoint['value' + index] || 0,
                        valueLabel: dataPoint.valueLabel,
                        mentionCount: dataPoint.mentionCount,
                        rawStartDate: dataPoint.rawStartDate || dataPoint.rawDateFacetFrom,
                        rawEndDate: dataPoint.rawEndDate || dataPoint.rawDateFacetTo
                    });
                });
                s.dataProvider.next(newDataPoints);
            });
            break;
        case ReportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME:
            data = (block.displayElement as ChartDisplayElementModel).series[0].dataProvider.getValue();
            data.forEach(dataPoint => {
                dataPoint.mappingKeys = dataPoint.mappingKeys || { author: dataPoint.key || dataPoint.label };
                dataPoint.value = dataPoint.value || dataPoint['value0'];
            });
            (block.displayElement as ChartDisplayElementModel).series[0].dataProvider.next(data);
            break;
        case ReportBlockTypeEnum.TOP_10_OUTLETS:
            data = (block.displayElement as ChartDisplayElementModel).series[0].dataProvider.getValue();
            data.forEach(dataPoint => {
                dataPoint.mappingKeys = dataPoint.mappingKeys || { outlet: dataPoint.key || dataPoint.label };
                dataPoint.value = dataPoint.value || dataPoint['value0'];
            });
            (block.displayElement as ChartDisplayElementModel).series[0].dataProvider.next(data);
            break;
        case ReportBlockTypeEnum.TOP_HASHTAGS:
            data = (block.displayElement as ChartDisplayElementModel).series[0].dataProvider.getValue();
            data.forEach(dataPoint => {
                dataPoint.mappingKeys = dataPoint.mappingKeys || { hashtag: dataPoint.key || dataPoint.label };
                dataPoint.value = dataPoint.value || dataPoint['value0'];
            });
            (block.displayElement as ChartDisplayElementModel).series[0].dataProvider.next(data);
            break;
        case ReportBlockTypeEnum.SENTIMENT_BREAKDOWN_COMPARISON:
        case ReportBlockTypeEnum.MEDIA_TYPE_BREAKDOWN_COMPARISON:
            (block.displayElement as ChartDisplayElementModel).series.forEach(s => {
                newDataPoints = [];
                data = s.dataProvider.getValue();
                data.forEach((dataPoint, index) => {
                    newDataPoints.push({
                        label: s.label,
                        mappingKeys: dataPoint.mappingKeys || {
                            source: s.label,
                            [block.type.key === ReportBlockTypeEnum.SENTIMENT_BREAKDOWN_COMPARISON ? 'sentiment' : 'mediaType']: dataPoint.id
                        },
                        value: dataPoint.value || dataPoint['value' + index] || dataPoint['xValue'],
                        valueLabel: dataPoint.valueLabel || dataPoint.label,
                        mentionCount: dataPoint.mentionCount || dataPoint['value' + index] || dataPoint['xValue'],
                        percent: dataPoint.percent
                    });
                });
                s.dataProvider.next(newDataPoints);
            });
            break;
        case ReportBlockTypeEnum.SENTIMENT_BREAKDOWN:
        case ReportBlockTypeEnum.MEDIA_TYPE_BREAKDOWN:
            data = (block.displayElement as ChartDisplayElementModel).series[0].dataProvider.getValue();
            const dataPoints = [];
            data.forEach(dataPoint => {
                dataPoints.push({
                    label: dataPoint.label,
                    mappingKeys: dataPoint.mappingKeys || {
                        source: (block.displayElement as ChartDisplayElementModel).series[0].label,
                        sentiment: dataPoint.id,
                        mediaType: dataPoint.id
                    },
                    value: dataPoint.value ?? dataPoint.xValue ,
                    valueLabel: dataPoint.valueLabel ?? dataPoint.label,
                    percent: dataPoint.percent
                });
            });
            (block.displayElement as ChartDisplayElementModel).series[0].dataProvider.next(dataPoints);
            break;
        case ReportBlockTypeEnum.SHARE_OF_VOICE:
        case ReportBlockTypeEnum.COVERAGE_COMPARISON: {
            (block.displayElement as ChartDisplayElementModel).series.forEach(s => {
                data = s.dataProvider.getValue();
                if (data.previousPeriodData) {
                    const previousPeriodData = {
                        mappingKeys: data.previousPeriodData[0]?.mappingKeys || {
                            source: data.previousPeriodData[0].label,
                            date: 0
                        },
                        value: data.previousPeriodData[0]?.value ?? data.previousPeriodData[0]?.xValue
                    };
                    s.previousPeriodDataProvider.next([previousPeriodData]);
                    const currentPeriodData = {
                        mappingKeys: data.currentPeriodData[0]?.mappingKeys || {
                            source: data.currentPeriodData[0].label,
                            date: 1
                        },
                        value: data.currentPeriodData[0]?.value ?? data.currentPeriodData[0]?.xValue
                    };
                    s.dataProvider.next([currentPeriodData]);
                } else {
                    const currentPeriodData = {
                        mappingKeys: data[0].mappingKeys || {
                            source: data[0].label,
                            date: 0
                        },
                        value: data[0].value || data[0].xValue
                    };
                    s.dataProvider.next([currentPeriodData]);
                }
            });
            break;
        }
        case ReportBlockTypeEnum.SENTIMENT_TREND:
            const sentiments = (block.displayElement as ChartDisplayElementModel).sentiments;
            data = (block.displayElement as ChartDisplayElementModel).series[0].dataProvider.getValue();
            const currentSentimentPeriodData = [];
            (data.currentSentimentPeriodData || data).forEach(dataPoint => {
                sentiments.forEach(sentiment => {
                    let momentStart;
                    if (!dataPoint.startTimeExport) {
                        const startTime = dataPoint.xValue;
                        momentStart = moment(startTime).startOf(dataPoint.timeScale || 'day');
                    }
                    currentSentimentPeriodData.push({
                        mappingKeys: dataPoint.mappingKeys || {
                            date: dataPoint.xValue,
                            sentiment: sentiment,
                        },
                        value: dataPoint.value ?? dataPoint[`yValue_${sentiment}`],
                        percent: dataPoint.percent ?? (dataPoint[`yValue_${sentiment}`]*100) / dataPoint.mentionCount,
                        valueLabel: dataPoint.valueLabel ?? `Reports.formField.analysis.${sentiment}`,
                        mentionCount: dataPoint.mentionCount ,
                        startTimeExport: dataPoint.startTimeExport || momentStart.format('YYYY/MM/DD HH:mm'),
                        endTimeExport: dataPoint.endTimeExport || moment().format('YYYY/MM/DD HH:mm'),
                        rawStartDate: dataPoint.rawStartDate || dataPoint.xValue,
                        rawEndDate: dataPoint.rawEndDate || moment().valueOf(),
                        timeScale: dataPoint.timeScale || 'day',
                    });
                });
            });
            (block.displayElement as ChartDisplayElementModel).series[0].dataProvider.next(currentSentimentPeriodData);
            break;
        case ReportBlockTypeEnum.SOCIAL_COVERAGE_BY_NETWORK: {
            data = (block.displayElement as ChartDisplayElementModel).series[0].dataProvider.getValue();
            const currentPeriodData = [];
            (data.currentPeriodData || data).forEach(dataPoint => {
                currentPeriodData.push({
                    label: dataPoint.label,
                    mappingKeys: dataPoint.mappingKeys || {
                        date: 0,
                        mediaType: dataPoint.id
                    },
                    value: dataPoint.value ?? dataPoint.xValue ,
                    valueLabel: dataPoint.valueLabel ?? dataPoint.label,
                    percent: dataPoint.percent
                });
            });
            if (data.previousPeriodData) {
                currentPeriodData.forEach(x => x.mappingKeys['date'] = 1);
                const previousPeriodData = [];
                data.previousPeriodData.forEach(dataPoint => {
                    previousPeriodData.push({
                        label: dataPoint.label,
                        mappingKeys: dataPoint.mappingKeys || {
                            date: 0,
                            mediaType: dataPoint.id
                        },
                        value: dataPoint.value ?? dataPoint.xValue ,
                        valueLabel: dataPoint.valueLabel ?? dataPoint.label,
                        percent: dataPoint.percent
                    });
                });
                (block.displayElement as ChartDisplayElementModel).series[0].previousPeriodDataProvider.next(previousPeriodData);
            }
            (block.displayElement as ChartDisplayElementModel).series[0].dataProvider.next(currentPeriodData);
            break;
        }
    }

    block['version'] = '2.0';
    return block;
}
